import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  all() {
    return fetch(api('collections'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.COLLECTIONS_FETCH_COMPLETE,
        collections: response.data.collections,
      }))
      .catch(dispatchHttpError);
  },

  fetch(id) {
    return fetch(api(`collections/${id}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.COLLECTION_FETCH_COMPLETE,
        collection: response.data,
      }))
      .catch(dispatchHttpError);
  },

  fetchArchived(){
    return fetch(api(`archive`),{
      headers:  {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      }
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.COLLECTION_ARCHIVED_FETCH_COMPLETE,
        collections: response.data,
      }))
      .catch(console.error());
  }
}
